import { render, staticRenderFns } from "./DebtorAgingReportSideMenu.vue?vue&type=template&id=1c2fb751&scoped=true"
import script from "./DebtorAgingReportSideMenu.vue?vue&type=script&lang=js"
export * from "./DebtorAgingReportSideMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c2fb751",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c2fb751')) {
      api.createRecord('1c2fb751', component.options)
    } else {
      api.reload('1c2fb751', component.options)
    }
    module.hot.accept("./DebtorAgingReportSideMenu.vue?vue&type=template&id=1c2fb751&scoped=true", function () {
      api.rerender('1c2fb751', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/debtoragingreport/DebtorAgingReportSideMenu.vue"
export default component.exports